import moment from "moment";

export const getCodeLife = (expTime) => {
    return Math.ceil(moment(moment(expTime).valueOf() - moment().valueOf()) / 1000)
}